<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="mt-3">
      <label class="label-form">Are You Sure You Want To Delete this Lead?
      </label>
    </div>
    <div class="mt-2">
      <label class="label-form">Password <span class="text-danger">*</span></label>
      <input class="form-control password" name="password" v-model="password"
        placeholder="Enter Your Password To Delete " type="password" id="password" required />
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
        Close
      </button>
      <button type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-danger text-light btn-sm ml-1" @click="save">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Delete
      </button>
    </div>
  </form>
</template>

<script>
  import axios from "axios";

  export default {
    props: ["action", "formData", "pageNumber", "status"],
    data: function () {
      return {
        isMiniLoading : false,
        password: this.formData.password,
        st: "",
      };
    },
    computed: function () {
      if (localStorage.getItem("st") != undefined) {
        this.st = localStorage.getItem("st");
      } else {
        this.st = 0;
      }
    },
    methods: {
      save() {
        this.isMiniLoading = true;
        let demo_id = this.formData.user;
        let page_no = this.formData.pageNumber;
        let self = this;
        let password = self.password;
        let user_id = localStorage.getItem("admin_id");
        if (password != "") {
             const permission = {
        headers: {
          'X-Permission': 'lead_delete' 
        }
      };
          axios
            .post("/admin/users/delete_demo_request", {
              password: password,
              user_id: user_id,
              id: demo_id,
            },permission)
            .then((response) => {
              this.isMiniLoading = false;
              if(response.data.flag == '1'){
                this.$toast.success('Lead deleted successfully!');
                 window.$("#modal").modal("hide");
              }else{
                this.$toast.error('You have entered wrong password');
              } 
              this.$store.dispatch("users/getAllDemoRequests", [page_no, "", this.formData.status, "", "", "", "", "", "", this.formData.color ? this.formData.color : "", this.formData.followup_filter, 'all' , 'all']);
            })
            .catch((error) => {
              this.isMiniLoading = false;
              this.$toast.error(error);
            });
        } else {
          this.isMiniLoading = false;
          this.$toast.warning("Please Enter Password First");
        }
      },
    },
  };
</script>